import { createAction, props } from "@ngrx/store";
import { IVesselTransitStatus, IVesselVisit, IVesselVisitGridItem } from "../model/vessel-visit";
import { IServiceApplicationTypes, IVesselActivity, IVesselActivityPurposeDropdown } from "../model";
import { ILocationForNOA, ILocationType, IOrganization, IOrganizationType, IVessel, IVesselOrientation, ICargoType, ICargoUnitType, ICargoOperation } from "@pmis3/master-data-core";
import { ILadenStatusDropdown } from "../../vessel-stop";
import { VesselActivityIndicesAndStopType } from 'libs/vessel-activity/vessel-activity-core/src/lib/vessel-visit/model/vessel-activity';

export enum VesselVisitActionTypes {
    LoadVesselVisits = "[VesselVisit Page] Load VesselVisits",
    LoadSuccess = "[VesselVisit Page] Load Success",
    LoadFail = "[VesselVisit Page] Load Fail",
    ComponentLoaded = "[VesselVisit Page] Component Loaded",
    UpdateSelectedVesselVisit = "[VesselVisit Page] Update Selected Vessel Visit",
    UpdateSelectedVesselActivitiesIndices = "[VesselVisit Detail Page] Update Indices of Selected Vessel Activities",
    UpdateVesselActivitiesBeingEdited = "[VesselVisit Detail Page] Update Vessel Activities Being Edited",
    ExitEditNOAMode = "[VesselVisit Page] Exit edit NOA mode",
    LoadInputPPAData = "[VesselVisit Page] Load input ppa data",
    LoadAgentOrganization = "[VesselVisit Page] Load organization of agent",
    UpdateOriginalSelectedVesselVisit = "[VesselVisit Page] Update Original Selected Vessel Visit",
    UpdateOriginalSelectedVesselVisitForTestData = "[VesselVisit Page] Update Original Selected Vessel Visit with Test Data",
    UpdateOriginalSelectedVesselVisitForTestDataSuccess = "[VesselVisit Page] Update Original Selected Vessel Visit with Test Data Success",
}

export const LoadVesselVisits = createAction(
    VesselVisitActionTypes.LoadVesselVisits
)

export const LoadVesselVisitFail = createAction(
  VesselVisitActionTypes.LoadFail,
  props<{ error: string }>()
)

export const ComponentLoaded = createAction(
  VesselVisitActionTypes.ComponentLoaded
)

export const UpdateSelectedVesselVisit = createAction(
 VesselVisitActionTypes.UpdateSelectedVesselVisit,
 props<{ selectedVesselVisit: IVesselVisit }>()
)

export const LoadAgentOrganization = createAction(
  VesselVisitActionTypes.LoadAgentOrganization,
  props<{ organization: IOrganization}>()
)

export const UpdateSelectedVesselActivitiesIndices = createAction(
  VesselVisitActionTypes.UpdateSelectedVesselActivitiesIndices,
  props<{ indices: VesselActivityIndicesAndStopType[]}>()
)

export const UpdateVesselActivitiesBeingEdited = createAction(
  VesselVisitActionTypes.UpdateVesselActivitiesBeingEdited,
  props<{ vesselActivities: IVesselActivity[] | undefined, editingIndices?: VesselActivityIndicesAndStopType[] }>()
)

export const ExitEditNOAMode = createAction(
  VesselVisitActionTypes.ExitEditNOAMode
)

export const LoadInputPPAData = createAction(
  VesselVisitActionTypes.LoadInputPPAData,
  props<{
    ladenStatuses: ILadenStatusDropdown[],
    purposes: IVesselActivityPurposeDropdown[],
    vesselVisits: IVesselVisitGridItem[],
    locations: ILocationForNOA[],
    terminals: ILocationForNOA[],
    locationTypes: ILocationType[],
    organizations: IOrganization[],
    organizationTypes: IOrganizationType[],
    vessels: IVessel[],
    vesselOrientations: IVesselOrientation[],
    serviceApplicationTypes: IServiceApplicationTypes[],
    cargoTypes: ICargoType[],
    cargoUnitTypes: ICargoUnitType[],
    cargoOperations: ICargoOperation[],
    transitStatuses: IVesselTransitStatus[]
  }>()
)

export const UpdateOriginalSelectedVesselVisit = createAction(
  VesselVisitActionTypes.UpdateOriginalSelectedVesselVisit,
  props<{ vesselVisit: IVesselVisit }>()
)

export const UpdateOriginalSelectedVesselVisitForTestData = createAction(
  VesselVisitActionTypes.UpdateOriginalSelectedVesselVisitForTestData,
  props<{ vesselVisitId: number }>()
)

export const UpdateOriginalSelectedVesselVisitForTestDataSuccess = createAction(
  VesselVisitActionTypes.UpdateOriginalSelectedVesselVisitForTestDataSuccess,
  props<{ vesselVisit?: IVesselVisit }>()
)